import React from "react";
//import { Pannasonic } from "../svg/partnerlogo/Pannasonic";
//import { RingCentral } from "../svg/partnerlogo/RingCentral";
//import { Yealink } from "../svg/partnerlogo/Yealink";
import phone01 from "../../images/img-1.png";
import phone02 from "../../images/img-2.png";
import phone03 from "../../images/img-3.png";
import phone04 from "../../images/img-4.png";
import phone05 from "../../images/img-5.png";
import phone06 from "../../images/img-6.png";

export function OurPartners() {
  return (
    <section className="our-partner">
      <div className="que-our-partners">
        <div className="que-partner-title">
          <h1>Compare & Save </h1>
          <h3>Multiple Brands To Select From Our Partner Offering </h3>
        </div>
        <div className="partner-logo-container">
        <img className="que-logo" src={phone01} alt="X7C Enterprise IP Phone" />
        <img className="que-logo" src={phone02} alt="CISCO 8851 IP Phone" />
        <img className="que-logo" src={phone03} alt="NEC ITK-32LCG-1A IP Phone" />
        <img className="que-logo" src={phone04} alt="T48U-front" />
        <img className="que-logo" src={phone05} alt="1050i-front" />
        <img className="que-logo" src={phone06} alt="gxp2170_front_2" />
          {/* <Yealink />
          <RingCentral />
          <Pannasonic /> */}
        </div>
        <div className="que-partner-title">
          <p>
            We compare premium business phone systems suppliers from local and
            national to find the right solution at right price for your business
            to increase productivity.
          </p>
        </div>
      </div>
    </section>
  );
}
